// extracted by mini-css-extract-plugin
module.exports = {"form":"form__rn4hV"};